import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Book, Headphones, ShoppingCart, Calendar, Check, Lock, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
const components = [{
  icon: <Book className="w-6 h-6 text-primary" data-id="element-16" />,
  title: 'eBook Principal: El Protocolo D-R',
  desc: 'Guía completa paso a paso de 14 días',
  value: 47,
  isBonus: false
}, {
  icon: <Headphones className="w-6 h-6 text-primary" data-id="element-17" />,
  title: 'Sección de Preguntas Frecuentes',
  desc: 'Respuestas a las dudas más comunes sobre el protocolo',
  value: 27,
  isBonus: false
}, {
  icon: <ShoppingCart className="w-6 h-6 text-primary" data-id="element-18" />,
  title: 'Checklist: Lista de Supermercado Hígado Limpio',
  desc: 'Optimizada para supermercados en USA',
  value: 17,
  isBonus: false
}, {
  icon: <Calendar className="w-6 h-6 text-accent" data-id="element-19" />,
  title: 'Planificador: Calendario de 14 Días',
  desc: 'Con tracker de energía y síntomas diario',
  value: 17,
  isBonus: true
}];
export function BundleStack() {
  return <SectionWrapper bgColor="warmWhite" data-id="element-20">
      <div id="oferta" className="scroll-mt-8" data-id="element-21">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark mb-6 leading-tight text-center" data-id="element-22">
          Todo Lo Que Recibes Hoy
        </h2>

        <div className="space-y-3 mb-6" data-id="element-23">
          {components.map((comp, idx) => <div key={idx} className={`
              bg-white p-5 md:p-6 rounded-2xl shadow-sm border flex flex-col sm:flex-row gap-4 sm:items-center justify-between
              ${comp.isBonus ? 'border-accent/50 bg-accent/5' : 'border-gray-100'}
            `} data-id="element-24">
              <div className="flex items-start gap-4" data-id="element-25">
                <div className={`
                  w-12 h-12 rounded-xl flex items-center justify-center shrink-0
                  ${comp.isBonus ? 'bg-accent/20' : 'bg-primary/10'}
                `} data-id="element-26">
                  {comp.icon}
                </div>
                <div data-id="element-27">
                  {comp.isBonus && <span className="text-xs font-bold text-accent uppercase tracking-wider mb-1 block" data-id="element-28">
                      🎁 Bono Especial
                    </span>}
                  <h4 className="font-bold text-dark text-lg" data-id="element-29">{comp.title}</h4>
                  <p className="text-gray-600 text-sm" data-id="element-30">{comp.desc}</p>
                </div>
              </div>

              <div className="flex items-center justify-between sm:flex-col sm:items-end gap-2 mt-4 sm:mt-0 pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-100" data-id="element-31">
                <div className="text-sm text-gray-400 line-through" data-id="element-32">
                  Valor: ${comp.value}
                </div>
                <div className="flex items-center gap-1 text-success font-bold text-sm bg-success/10 px-3 py-1 rounded-full" data-id="element-33">
                  <Check className="w-4 h-4" data-id="element-34" /> INCLUIDO
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-dark text-white rounded-3xl p-6 text-center shadow-xl relative overflow-hidden mb-6" data-id="element-35">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-36"></div>
          <div className="relative z-10" data-id="element-37">
            <p className="text-gray-400 font-medium mb-2 uppercase tracking-widest text-sm" data-id="element-38">
              Valor Total Real
            </p>
            <p className="text-3xl text-gray-500 line-through decoration-urgency decoration-2 mb-1" data-id="element-39">
              $108 USD
            </p>
            <p className="text-accent text-sm font-bold mb-4 uppercase tracking-wider" data-id="element-40">
              🔥 Precio de Lanzamiento por Tiempo Limitado
            </p>

            <a href="https://pay.hotmart.com/T105430647K?bid=1776800957963" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="bg-accent text-dark py-5 px-8 rounded-2xl inline-block w-full max-w-sm shadow-lg hover:shadow-glow transition-shadow duration-300 cursor-pointer" data-id="element-41">
              <p className="font-bold uppercase tracking-wider text-sm mb-1" data-id="element-42">
                Tu Inversión Hoy
              </p>
              <p className="font-serif text-5xl font-bold" data-id="element-43">
                $6.39 <span className="text-2xl" data-id="element-44">USD</span>
              </p>
              <p className="text-sm font-medium mt-1 opacity-80" data-id="element-45">
                Pago único — Sin suscripciones
              </p>
            </a>
          </div>
        </div>

        <div className="max-w-md mx-auto mb-6" data-id="element-46">
          <CTAButton href="https://pay.hotmart.com/T105430647K?bid=1776800957963" onClick={() => trackAddToCart()} data-id="element-47" />
        </div>

        <div className="bg-white rounded-2xl p-5 border border-gray-200 max-w-md mx-auto" data-id="element-48">
          <div className="flex flex-col items-center gap-3 text-center" data-id="element-49">
            <div className="flex items-center gap-2 text-primary font-bold text-sm" data-id="element-50">
              <ShieldCheck className="w-5 h-5" data-id="element-51" />
              Garantía de 14 Días — Compra Sin Riesgo
            </div>
            <div className="flex items-center gap-2 text-gray-600 text-sm" data-id="element-52">
              <Lock className="w-4 h-4" data-id="element-53" />
              Checkout 100% Seguro por Hotmart
            </div>
            <div className="flex items-center gap-3 pt-2 border-t border-gray-100 w-full justify-center" data-id="element-54">
              <span className="text-xs text-gray-400 font-bold tracking-wider" data-id="element-55">
                VISA | MASTERCARD | PAYPAL | PIX | AMEX
              </span>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}